import { isEmpty } from 'shared/utils/objectUtils'

type ToggleValue = string | number | boolean | undefined

export const isRedPointsActive = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'redpoints.active')
  ) {
    return true
  }

  return Boolean(toggles['redpoints.active'])
}

export const showInsurancePrescriptionBonus = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(
      toggles,
      'eRX.showInsurancePrescriptionBonus'
    )
  ) {
    return true
  }

  return Boolean(toggles['eRX.showInsurancePrescriptionBonus'])
}

export const isNowV4Active = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'useNowApiV4')
  ) {
    return true
  }

  return Boolean(toggles['useNowApiV4'])
}

export const isNewAvailabilityServiceActive = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(
      toggles,
      'newAvailabilityServiceActive'
    )
  ) {
    return false
  }

  return Boolean(toggles['newAvailabilityServiceActive'])
}

export const useSaeConversationalChat = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'saeConversationalChat')
  ) {
    return false
  }

  return Boolean(toggles['saeConversationalChat'])
}

export const isGenderNeutralNewsletterSubscription = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(
      toggles,
      'isGenderNeutralNewsletterSubscription'
    )
  ) {
    return false
  }

  return Boolean(toggles['isGenderNeutralNewsletterSubscription'])
}

export const isMeetergoScheduling = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  const toggleName = 'useMeetergoScheduling'
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, toggleName)
  ) {
    return false
  }

  return Boolean(toggles[toggleName])
}

export const isOneTimePasswordLoginEnabled = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(
      toggles,
      'oneTimePasswordLoginEnabled'
    )
  ) {
    return false
  }

  return Boolean(toggles['oneTimePasswordLoginEnabled'])
}

export const isUseMarketplaceVolumeBasedPricesEnabled = (
  toggles: Record<string, ToggleValue> = {}
): boolean => {
  const toggleName = 'useMarketplaceVolumeBasedPrices'
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, toggleName)
  ) {
    return false
  }

  return Boolean(toggles[toggleName])
}
